import React from 'react'
import { Button } from '@chilecompra/react-kit/components'
import { REACT_APP_MP_API_URL } from '../../config/settings/environment'
import DownloadsNavButton from '../../components/Navigation/DownloadsNavButton'
import { Description, GridContainer, GridItem, Root, Subtitle, Title } from './DownloadDevelopmentToolsSection.styles'

/**
 * The DownloadDevelopmentToolsSection's container.
 */
const DownloadDevelopmentToolsSection = () => {
  const handleClickLink = url => () => window.open(url, '_top')

  return (
    <Root>
      <GridContainer padding="0 0 26px">
        <DownloadsNavButton />
        <GridItem xs={10} sm={11}>
          <Title>Herramientas para desarrolladores</Title>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 22px">
        <GridItem xs={12}>
          <Subtitle>API Mercado Público</Subtitle>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 17px">
        <GridItem xs={12}>
          <Description>
            A través de la API Mercado Público puedes acceder directamente a los datos del mercado de compras públicas,
            generados a través del portal www.mercadopublico.cl. Esta información comprende datos reales y en línea,
            referidos a licitaciones y órdenes de compra generadas por los organismos públicos que realizan sus compras
            en Mercado Público.
          </Description>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 45px">
        <GridItem xs={12}>
          <Button color="primary" variant="outlined" onClick={handleClickLink(REACT_APP_MP_API_URL)}>
            Ir al sitio
          </Button>
        </GridItem>
      </GridContainer>
    </Root>
  )
}

export default DownloadDevelopmentToolsSection
